import { mergePresets } from '@bas/ui/optimus-ui';
import { theme } from '@bas/ui/optimus-ui/base/losteria';
import { StyleOptions } from '@openng/optimus-ui-themes';
import { customerOverride } from './customer-override';

export const customerTheme = mergePresets(mergePresets(theme, {
	extend: {
		primitive: {
			spacing: {
				absolute: '1',
			},
		},
		semantic: {
			formField: {
				lineHeight: '1.5',
			},
		},
	},
	components: {
		button: {
			extend: {
				lineHeight: '1.5',
				borderWidth: '2px',
			},
		},
		datatable: {
			css: ({}, css: string) => `
				${ css }
				.p-datatable :is(th, td).minWidth {
					width: 1%;
					white-space: nowrap;
				}
			`,
		},
		select: {
			css: ({ dt }, css: string) => `
				${ css }
				.p-select-option:has(.lessimportant) {
					font-style: italic;
					border-top: 1px dotted ${ dt('select.placeholder.color') };
				}
				*:has(> .p-select-option > .lessimportant) + * .p-select-option:has(.lessimportant) {
					border-top-style: none;
				}
			`,
		},
		tooltip: {
			extend: {
				error: {
					maxWidth: '300px',
				},
			},
			root: {
				maxWidth: '500px',
			},
		},
	},
	css: ({ dt }: StyleOptions, css: string) => `
		${ css }
		:is(div, .bui-field):has(> :is(.p-checkbox, .p-radiobutton):first-child + label:last-child) {
			display: flex;
			gap: ${ dt('spacing.xs') };
			align-items: start;
		}
		:is(div, .bui-field) > :is(.p-checkbox, .p-radiobutton):first-child:has(+ label:last-child) {
			flex-shrink: 0;
			translate: 0 4px;
		}
		:is(div, .bui-field) > :is(.p-checkbox, .p-radiobutton):first-child + label:last-child {
			cursor: pointer;
		}
	`,
}), customerOverride);
